import { render, staticRenderFns } from "./TipoContactoPantalla.vue?vue&type=template&id=3e56a6fa&"
import script from "./TipoContactoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports